<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Gadai Elektronik</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="detail-data-wrapper mb-4">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                        <b-col v-if="dataElek.noFaktur != null"><strong>{{ dataElek.noFaktur }}</strong></b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Status Gadai</b-col>
                        <b-col v-if="dataElek.statusGadai != null">{{ dataElek.statusGadai }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <div class="detail-data-wrapper mb-4">
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                            <b-col v-if="dataElek.anggota.noAnggota != null"><strong>{{ dataElek.anggota.noAnggota }}</strong></b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                            <b-col v-if="dataElek.anggota.jenisIdentitas != null">{{ dataElek.anggota.jenisIdentitas }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                            <b-col v-if="dataElek.anggota.noIdentitas != null">{{ dataElek.anggota.noIdentitas }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Nama</b-col>
                            <b-col v-if="dataElek.anggota.namaAnggota != null">{{ dataElek.anggota.namaAnggota }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Alamat</b-col>
                            <b-col v-if="dataElek.anggota.alamat != null">{{ dataElek.anggota.alamat }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                            <b-col v-if="dataElek.anggota.noHp != null">{{ dataElek.anggota.noHp }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA BARANG</h6>
                    <b-form-group label="Jenis Barang">
                        <multiselect
                            v-model="dataElek.barang.jenis" 
                            :options="optElekJenis" 
                            :internal-search="true"
                            :allow-empty="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="-- Please select an option --"
                            disabled
                        />
                    </b-form-group>
                    <b-form-group label="Merk Barang">
                        <multiselect
                            v-model="dataElek.barang.merk" 
                            :options="optElekMerk" 
                            :internal-search="true"
                            :allow-empty="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="-- Please select an option --"
                            disabled
                        />
                    </b-form-group>
                    <b-form-group label="Tipe">
                        <b-form-select v-model="dataElek.barang.tipe" name="gadaiTipeBarang" required disabled>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                <b-form-select-option  v-for="(item, idx) in optElekTipe" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                    {{ item.name }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Tahun / Generasi"  v-if="optElekTahun.length != 0">
                        <b-form-select v-model="input.tahunGadai" name="gadaiTahunElektronik" required disabled>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                <b-form-select-option v-for="(item, idx) in optElekTahun" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                    {{ item.name }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="dataElek.barang.jenis != null && dataElek.barang.jenis.id == 2" label="Spesifikasi Laptop"><!-- TODO HARDCODED JENIS BARANG -->
                        <b-input v-model="input.spesifikasiLaptop" maxlength="200" />
                    </b-form-group>
                    <b-form-group label="Kondisi / Grade Barang">
                        <b-form-select v-model="input.dataKondisi" name="gadaiGradeBarangClass" :options="optElekKondisi" required disabled>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="dataElek.barang.jenis != null && dataElek.barang.jenis.id == 2" label="RAM Laptop" disabled ><!-- TODO HARDCODED JENIS BARANG -->
                        <b-input-group append="GB">
                            <b-form-select v-model="input.ram" :options="optRAM" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group v-if="dataElek.barang.jenis.id == 2" label="Hardisk Laptop" disabled>
                        <b-input-group style="margin-left: -15px;">
                            <b-col md="6">
                                <b-form-select
                                    name="gadaiJenisHardisk"
                                    v-model="input.gadaiJenisHardisk"
                                    :options="jenisHardisk"
                                    required
                                />
                            </b-col>
                            <b-col md="6">
                                <b-form-select v-if="input.gadaiJenisHardisk == null " :disabled="input.gadaiJenisHardisk == null"/>
                                <b-form-select v-else-if="input.gadaiJenisHardisk == 'HDD / SD'" name="gadaiSizeHardisk" v-model="input.gadaiSizeHardisk" :options="optHardiskHDD" />
                                <b-form-select v-else-if="input.gadaiJenisHardisk == 'SSD'" name="gadaiSizeHardisk" v-model="input.gadaiSizeHardisk" :options="optHardiskSSD" />
                            </b-col>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="No. Imei/ SN">
                        <b-form-input v-model="dataElek.barang.noImei" name="gadaiNoImei" required disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Password" description="Bila barang gadai tidak menggunakan password, input ini dapat dikosongkan.">
                        <b-form-input v-model="dataElek.barang.password" name="gadaiPassword"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Warna">
                        <b-form-select v-model="dataElek.barang.warna.id" name="gadaiWarnaBarang" :options="optElekWarna" required>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <!-- <b-form-group label="Kondisi/ Kerusakan/ Keterangan Lainnya">
                        <b-form-textarea
                            id="textarea"
                            v-model="dataElek.barang.keterangan" name="gadaiKondisi"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                        <span class="smallText text-muted">
                            * Dapat digunakan juga untuk mencatat detil barang gadai bilamana barang tidak ditemukan (Menggunakan pilihan ‘Lainnya’)”
                        </span>
                    </b-form-group> -->
                    <b-form-group label="Kelengkapan Barang">
                        <div v-if="optKelengkapanBarang.length == 0" class="text-muted">
                            Tidak ada kelengkapan dari jenis barang yang dipilih.
                        </div>
                   
                        <b-form-checkbox v-for="item in optKelengkapanBarang" v-bind:key="item.id" v-model="item.checked" inline  >
                            {{ item.name }}
                        </b-form-checkbox>
                 
                    </b-form-group>
            
                   
                    <b-form-group label="Spesifikasi Barang (Jenis)">
						<b-row>
							<b-col md="6">
								<span class="text-muted">Penambahan</span>
								<div v-if="optElekSpekJenis.penambahan.length == 0" class="text-muted mb-2">
									Tidak ada penambahan spesifikasi dari jenis barang yang dipilih.
								</div>
								<b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiJenis" name="gadaiPenambahanSpekJenisBarang" disabled>
									<b-form-checkbox class="d-block" v-for="item in optElekSpekJenis.penambahan" v-bind:key="item.id" :value="item.id">
										{{ item.name }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</b-col>
							<b-col md="6">
								<span class="text-muted">Pengurangan</span>
								<div v-if="optElekSpekJenis.pengurangan.length == 0" class="text-muted mb-2" >
									Tidak ada pengurangan spesifikasi dari jenis barang yang dipilih.
								</div>
								<b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiJenis" name="gadaiPenguranganSpekJenisBarang" disabled>
									<b-form-checkbox class="d-block" v-for="item in optElekSpekJenis.pengurangan" v-bind:key="item.id" :value="item.id">
										{{ item.name }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</b-col>
						</b-row>
                    </b-form-group>
                    <b-form-group label="Spesifikasi Barang (Merk)">
						<b-row>
							<b-col md="6">
								<span class="text-muted">Penambahan</span>
								<div v-if="optElekSpekMerk.penambahan.length == 0" class="text-muted mb-2">
									Tidak ada penambahan spesifikasi dari merk barang yang dipilih.
								</div>
								<b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiMerk" name="gadaiPenambahanSpekMerkBarangElek" disabled>
									<b-form-checkbox class="d-block" v-for="item in optElekSpekMerk.penambahan" v-bind:key="item.id" :value="item.id">
										{{ item.name }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</b-col>
							<b-col md="6">
								<span class="text-muted">Pengurangan</span>
								<div v-if="optElekSpekMerk.pengurangan.length == 0" class="text-muted mb-2">
									Tidak ada pengurangan spesifikasi dari merk barang yang dipilih.
								</div>
								<b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiMerk" name="gadaiPenguranganSpekMerkBarangElek" disabled>
									<b-form-checkbox class="d-block" v-for="item in optElekSpekMerk.pengurangan" v-bind:key="item.id" :value="item.id">
										{{ item.name }}
									</b-form-checkbox>
								</b-form-checkbox-group>
							</b-col>
						</b-row>
                    </b-form-group>
                </div>
                
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                        <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal {{ input.foto.length }} Foto</div>
                        <FotoPendukungNonBaseFile 
                            v-for="item in input.foto" 
                            v-bind:key="item.index" 
                            :fotoPendukung="item" 
                            :length="input.foto.length" 
                            :minLength="minLengthFotoPendukung"
                            :lat="lat"
                            :long="long"
                            :isDisabledChange="item.isDisabledChange"
                            @remove="removeFotoPendukung"
                            @showModalCam="openModalCam" 
                            @showModalPreview="openModalPreview"
                        />
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">ALASAN PERUBAHAN</h6>
                    <b-form-group label="Keterangan/ Alasan Perubahan">
                        <b-form-textarea
                            id="textarea"
                            v-model="input.alasanPerubahan" name="alasanPerubahan"
                            rows="3"
                            max-rows="6"
                            required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="gadaiUpdateBtn" variant="primary">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Gadai Elektronik" alertMessage="Perubahan ini akan diperiksa dan disetujui oleh AM terlebih dahulu sebelum data gadai diubah" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah gadai elektronik ini?" @submit="onSubmit" />
        <ModalWebCam @photoTaken="setResult"  />
       
        <ModalPreview :fotoPreview="activeFotoPreview" show="true" />
    </div>
</template>
<script>
import FotoPendukungNonBaseFile from '../../../components/webcam/FotoPendukungNonBaseFile'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'edit-gadai-elektronik',
    components: {
        FotoPendukungNonBaseFile,
        ModalWebCam,
        ModalPreview
    },
    data(){
        return{
            checked:true,
            windowWidth : window.innerHeight,
            windowHeight : window.innerWidth,
            
            lat:0,
            long:0,
            
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isLoading: true,
            dataElek: {
                anggota: [],
                barang: {
                    foto: [],
                },
            },
            input:{
                foto: [],
                kelengkapanGadai: [],
                spesifikasiJenis:[],
                spesifikasiMerk:[],
                alasanPerubahan: "",
                tahunGadai: null,
                dataKondisi: null,
                ram: 1,
                spesifikasiLaptop: "",
                gadaiJenisHardisk: null,
                gadaiSizeHardisk: null
            },

            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",

            optElekJenis: [],
            optElekMerk: [],
            optElekTipe: [],
            optElekTahun: [],
            optElekKondisi: [],
            optElekWarna: [],
            optKelengkapanBarang: [],
            optElekSpekJenis: {
				penambahan : [],
				pengurangan : []
			},
            optElekSpekMerk: {
				penambahan : [],
				pengurangan : []
			},
            optRAM: [1, 2, 3, 4, 6, 8, 16, 32, 64, 128],

            jenisHardisk: ["HDD / SD", "SSD"],
            optHardiskHDD: ["< 199 (128GB)", "200 - 450 (250GB)", "451 - 900 (500GB)", "901 - 1900 (1TB)", "> 1901 (2TB)"],
            optHardiskSSD: ["100 - 450 (250GB)", "451 - 900 (500GB)", "901 - 1900 (1TB)", "> 1901 (2TB)"]

        }
    }, 
    watch: {
        'dataElek.barang.jenis': function(newVal) {
            if(this.isLoading != true){
                this.optElekMerk = []
                this.dataElek.barang.merk = null

                this.optKelengkapanBarang = []
                this.input.kelengkapanGadai = []

                this.optElekSpekJenis = {
					penambahan : [],
					pengurangan : []
				}
                this.input.spesifikasiJenis = []

                if(newVal == null) { return }

                // Lookup Merk
                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optElekMerk = response.data
                })

                // Lookup Kelengkapan Barang
                this.$axios.get(`barang-jenis/kelengkapan?jenisId=${newVal.id}`).then(response => {
                    this.optKelengkapanBarang = response.data
                })

                // Lookup Spek Jenis
                this.$axios.get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`).then(response => {
                    this.optElekSpekJenis = response.data
                })
            }

        },
        'dataElek.barang.merk': function(newVal) {

            if(this.isLoading != true){
                this.optElekTipe = []
                this.dataElek.barang.tipe = null

                this.optElekSpekMerk = {
					penambahan : [],
					pengurangan : []
				}
                this.input.spesifikasiBarangMerk = []

                if(newVal == null) { return }

                // Lookup Tipe
                this.$axios.get(`barang-tipe-v2/merk/${newVal.id}`).then(response => {
                    this.optElekTipe = response.data.types
                })

                // Lookup Spek Merk
                this.$axios.get(`barang-merk/spesifikasi?merkId=${newVal.id}`).then(response => {
                    this.optElekSpekMerk = response.data
                })

            }

        },
        'dataElek.barang.tipe': function(newVal) {

            if(this.isLoading != true){
                this.optElekTahun = []
                this.input.tahunGadai = null

                this.optElekKondisi = []
                this.input.dataKondisi = null

                if(newVal == null) { return }

                // Lookup Tahun
                this.$axios.get(`barang-tipe-v2/tahun/${newVal.id}`).then(response => {
                    this.optElekTahun = response.data
                })

                // Lookup Kondisi
                this.$axios.get(`barang-tipe-v2/kondisi/${newVal.id}`).then(response => {

                    this.optElekKondisi = response.data.map(item => {
                        return { value: item.id, text: item.name }
                    })

                })
            }

        },
        'input.gadaiJenisHardisk': function(newVal){
            if(newVal == 'HDD / SD'){
                if(this.input.gadaiSizeHardisk == '100 - 450 (250GB)'){
                    this.input.gadaiSizeHardisk = this.optHardiskHDD[0]
                }else if(this.input.gadaiSizeHardisk == undefined){
                    this.input.gadaiSizeHardisk = this.optHardiskHDD[0]
                }
            }else if(newVal == 'SSD'){
                if(this.input.gadaiSizeHardisk == '< 199 (128GB)'){
                    this.input.gadaiSizeHardisk = this.optHardiskSSD[0]
                }else if (this.input.gadaiSizeHardisk == undefined){
                    this.input.gadaiSizeHardisk = this.optHardiskSSD[0]
                }
            }
        }
    },
    methods: {
        canvasdl(){
            const canvas = document.getElementById('canvas');
            // Convert canvas to dataURL and log to console
            const dataURL = canvas.toDataURL('image/jpeg', 0.9)
        
            var newResult = this.$helper.resizeImage(dataURL)
            let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.input.foto[idx].fotoBarangPendukungBase64 = newResult
            this.input.foto[idx].activeFotoPendukungBase64 = newResult
            // Logs data:image/png;base64,wL2dvYWwgbW9yZ...
        },
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getJenisElek = this.$axios.get("barang-jenis/elektronik").then(response => {
                this.optElekJenis = response.data
            })

            let getWarnaElek = this.$axios.get("gadai/warna").then(response => {
                this.optElekWarna = response.data.map(item => { return { value: item.id, text: item.name } })
            })

            let getEditElek = this.$axios.get(`gadai/daftar-gadai/${this.id}/edit`).then(response => {
                this.dataElek = response.data
                let dataLaptop = this.dataElek.laptop
                if(dataLaptop != null) {
                    this.input.ram = dataLaptop.ram
                    this.input.spesifikasiLaptop = dataLaptop.spesifikasiLaptop
                    this.input.gadaiJenisHardisk = dataLaptop.gadaiJenisHardisk == '-' ? null : dataLaptop.gadaiJenisHardisk
                    this.input.gadaiSizeHardisk = dataLaptop.gadaiSizeHardisk == '-' ? null : dataLaptop.gadaiSizeHardisk
                }

                //----------------- Inisialisasi Data Foto -----------------
                
                for (var x of this.dataElek.foto) {
                    this.input.foto.push({
                        index: this.indexFotoPendukung, 
                        id: x.id, 
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: x.name,
                        urlFotoBarangPendukung: x.name,
                        isDisabledChange: true,
                    })
                    this.indexFotoPendukung++
                }

                if(this.dataElek.barang.jenis.id != null){
                    this.$axios.get(`barang-jenis/kelengkapan?jenisId=${this.dataElek.barang.jenis.id}`).then(response => {
                        for(var x of response.data){
                            this.optKelengkapanBarang.push({
                                id: x.id,
                                name: x.name,
                                isActive : x.isActive,
                                checked: false
                            })
                        }
                        //----------------- Inisialisasi Kelengkapn -----------------
                        for (var x of this.dataElek.barang.kelengkapan) {
                           
                            let idx = this.optKelengkapanBarang.findIndex(item => item.name == x.trim());
                          
                            this.optKelengkapanBarang[idx].checked = true 
                            if(idx != -1) this.input.kelengkapanGadai.push(this.optKelengkapanBarang[idx])
                        }
                    })
                    this.$axios.get(`barang-jenis/spesifikasi?jenisId=${this.dataElek.barang.jenis.id}`).then(response => {
                        this.optElekSpekJenis = response.data
                        for (var x of this.dataElek.barang.spesifikasi) {
                            //----------------- Inisialisasi Spesifikasi Jenis -----------------
                            
                            let idxSpekJenisPenambahan = this.optElekSpekJenis.penambahan.findIndex(item => item.id == x.id);
                            if(idxSpekJenisPenambahan >= 0){
                                this.input.spesifikasiJenis.push(this.optElekSpekJenis.penambahan[idxSpekJenisPenambahan].id)
							}
							let idxSpekJenisPengurangan = this.optElekSpekJenis.pengurangan.findIndex(item => item.id == x.id);
                            if(idxSpekJenisPengurangan >= 0){
                                this.input.spesifikasiJenis.push(this.optElekSpekJenis.pengurangan[idxSpekJenisPengurangan].id)
                            }
                        }
                    })
                    this.$axios.get(`barang-merk/jenis/${this.dataElek.barang.jenis.id}`).then(response => {
                        this.optElekMerk = response.data
                        if(this.dataElek.barang.merk.id != null){
                            this.$axios.get(`barang-merk/spesifikasi?merkId=${this.dataElek.barang.merk.id}`).then(response => {
                                this.optElekSpekMerk = response.data
                                for (var x of this.dataElek.barang.spesifikasi) {
                                    //----------------- Inisialisasi Spesifikasi Merk -----------------
                                    let idxSpekMerkPenambahan = this.optElekSpekMerk.penambahan.findIndex(item => item.id == x.id);
                                    if(idxSpekMerkPenambahan >= 0){
                                        this.input.spesifikasiMerk.push(this.optElekSpekMerk.penambahan[idxSpekMerkPenambahan].id)
									}
									let idxSpekMerkPengurangan = this.optElekSpekMerk.pengurangan.findIndex(item => item.id == x.id);
                                    if(idxSpekMerkPengurangan >= 0){
                                        this.input.spesifikasiMerk.push(this.optElekSpekMerk.pengurangan[idxSpekMerkPengurangan].id)
                                    }
                                }
                            })
                            this.$axios.get(`barang-tipe-v2/merk/${this.dataElek.barang.merk.id}`).then(response => {
                                this.optElekTipe = response.data.types
                                if(this.dataElek.barang.tipe.id !=null){
                                    this.$axios.get(`barang-tipe-v2/tahun/${this.dataElek.barang.tipe.id}`).then(response => {
                                        this.optElekTahun = response.data
                                        let idxTahunGadai = this.optElekTahun.findIndex(item=>item.name == this.dataElek.barang.tahun);
                                        this.input.tahunGadai=this.optElekTahun[idxTahunGadai]
                                    })
                                    this.$axios.get(`barang-tipe-v2/kondisi/${this.dataElek.barang.tipe.id}`).then(response => {
                                        this.optElekKondisi = response.data.map(item => {
                                            return { value: item.id, text: item.name }
                                        })
                                        let dataOptKondisi = JSON.parse(JSON.stringify(this.optElekKondisi))
                                        let dataGradeKondisi = dataOptKondisi.filter(item=> item.text == this.dataElek.barang.gradeKondisi.name)
                                        if(dataGradeKondisi.length != 0){
                                            this.input.dataKondisi = dataGradeKondisi[0].value
                                        }else{
                                            this.input.dataKondisi = null
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
                
            })
 
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.lat = position.coords.latitude
                    this.long = position.coords.longitude
                },
                error => {
                    console.log(error.message);
                },
            )

            Promise.all([getJenisElek, getWarnaElek, getEditElek]).then(() => {
                this.initStatus = 1
                this.isLoading = false
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            if (!this.$helper.validateArrayHaveValue(this.input.foto, 'activeFotoPendukungBase64')) {
                this.$helper.toastErr(this, "Harap unggah foto pendukung terlebih dahulu")
                return;
            }

            if(this.dataElek.barang.jenis.id == 2) { // TODO HARDCODED JENIS
                if(this.$helper.isNullOrEmpty(this.input.spesifikasiLaptop)) {
                    return this.$helper.toastErr(this, "Mohon mengisi spesifikasi laptop!")
                }

                if(this.$helper.isNullOrEmpty(this.input.gadaiJenisHardisk)) {
                    return this.$helper.toastErr(this, "Mohon mengisi Hardisk laptop!")
                }

                if(this.$helper.isNullOrEmpty(this.input.gadaiSizeHardisk)) {
                    return this.$helper.toastErr(this, "Mohon mengisi Hardisk laptop!")
                }
            }

            if(this.dataElek.barang.jenis.name.startsWith('Lainnya')){
                this.$helper.toastErr(this, "Jenis barang tidak boleh lainnya")
            }else if(this.dataElek.barang.jenis.id == null){
                this.$helper.toastErr(this, "Mohon isi jenis terlebih dahulu")
            }else if(this.dataElek.barang.merk.id == null){
                this.$helper.toastErr(this, "Mohon isi merk terlebih dahulu")
            }else if(this.dataElek.barang.tipe.id == null){
                this.$helper.toastErr(this, "Mohon isi tipe terlebih dahulu")
            }else{
                let payload = new FormData()
                this.id = this.$route.params.id

                //----------------- Append Data Gadai -----------------

                payload.append("id", this.id)
                payload.append("jenisPinjamanId", 1) // MARK HARDCODE
                payload.append("jenisBarangId", this.dataElek.barang.jenis.id)
                payload.append("merkId", this.dataElek.barang.merk.id)
                payload.append("tipeId", this.dataElek.barang.tipe.id)
                payload.append("kondisiId", this.input.dataKondisi)
                payload.append("warnaId", this.dataElek.barang.warna.id)
                // payload.append("imeiSn", this.dataElek.barang.noImei)
                payload.append("keterangan", this.dataElek.barang.keterangan)
                payload.append("keteranganRevisi ", this.input.alasanPerubahan)

                if(this.$helper.isNotNullAndNotEmpty(this.dataElek.barang.password)){
                    payload.append("password", this.dataElek.barang.password)
                }
                
                if(this.$helper.isNotNullAndNotEmpty(this.input.tahunGadai)) {
                    payload.append("tahunId", this.input.tahunGadai.id)
                }

                // Append all checked spesifikasi
                for(let spek of this.input.spesifikasiJenis) {
                    payload.append("spesifikasiId", spek)
                }

                for(let spek of this.input.spesifikasiMerk) {
                    payload.append("spesifikasiId", spek)
                }
                
                if(this.optKelengkapanBarang.length !=0){
                  
                    for(var item of this.optKelengkapanBarang ){
                        if(item.checked == true){
                            payload.append("kelengkapan", item.name)
                            }
                        }
                    }

                // Upload photo only if on final step
                let jsonFoto = []
                this.input.foto.forEach(function(entry) {
                    jsonFoto.push(entry.activeFotoPendukungBase64)  
                })
                payload.append("foto", JSON.stringify(jsonFoto))

                if(this.dataElek.barang.jenis.id == 2) { // TODO HARDCODED JENIS
                    payload.append("ram", this.input.ram)
                    payload.append("spesifikasiLaptop", this.input.spesifikasiLaptop)
                    payload.append("gadaiJenisHardisk", this.input.gadaiJenisHardisk)
                    payload.append("gadaiSizeHardisk", this.input.gadaiSizeHardisk)
                }
                
                //----------------- Submit Semua Data -----------------

                this.isSubmitting = true

                this.$axios.post(`gadai-crud/edit/${this.id}/elektronik`, payload, { timeout: 300000 }).then(response => {

                    if(response.data.name == 'REFRESH_KONDISI'){
                        this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                        this.input.dataKondisi = null
                        this.$axios.get(`barang-tipe-v2/kondisi/${this.dataElek.barang.tipe.id}`).then(response => {

                            this.optElekKondisi = response.data.map(item => {
                                return { value: item.id, text: item.name }
                            })

                        })
                    }else{
                        this.initStatus = 1
                        this.$helper.setFlash(`Perubahan gadai berhasil diajukan!`)
                        if(this.$route.path.includes("inquiry-faktur")){
                            let path = this.$route.path.split('/')
                            path.pop()
                            path.pop()
                            path = path.join("/")
                            this.$router.push({ path })
                        }else{
                            let path = this.$route.path.split('/')
                            path.pop()
                            path = path.join("/")
                            this.$router.push({ path })
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }

        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if(this.input.foto.length < 30){
                this.input.foto.unshift({ 
                    index: this.indexFotoPendukung, 
                    id: 0, 
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                    urlFotoBarangPendukung: null,
                    isDisabledChange: false,
                })
                this.indexFotoPendukung++;
            }else{
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.foto = this.input.foto.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if(this.dataElek.barang.jenis.name == 'Handphone' && this.dataElek.barang.noImei.length != 15){
                this.$helper.toastErr(this, "Apabila jenis barangnya Handphone, IMEI harus 15 karakter")
            }else{
                this.$bvModal.show("modal-confirm-edit")
            }
        },

        openModalCam(index){
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("modal-ambil-foto")
        },

        openModalPreview(index){
            this.activeFotoPreviewIndex = index
            let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.foto[idx].activeFotoPendukungBase64
            this.$bvModal.show("modal-preview-foto")
        },

        async setResult(result){
                 
            let formattedDate = this.$helper.formatTanggalDMY()
            let waktu = this.$helper.waktu24()
        
            //resize image
            var newResult = await this.$helper.resizeImage(result)

            //add timestamp & location
            let img = new Image()
            img.src = newResult
            img.onload = () => {
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')
                canvas.setAttribute("width", img.width);
                canvas.setAttribute("height", img.height);
                ctx.drawImage(img, 0, 0,)
                ctx.font = "14pt Arial";
                ctx.fillStyle = "#ffffff"; //<======= here
                ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
                ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
                ctx.fillText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
                ctx.strokeText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
                let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)

                let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPendukungIndex);
                this.input.foto[idx].fotoBarangPendukungBase64 = newBase64Str
                this.input.foto[idx].activeFotoPendukungBase64 = newBase64Str
            }
        },
    },

    created(){
        this.init()
    },
}
</script>
